<template>
    <button
		v-if="visibility"
		@click="$emit('click')"
		class="btn rp-start-conversation"
		:style="{
			color: textColor,
			border:'1px solid',
			borderColor: borderColor,
			backgroundColor: backgroundColor,
			borderRadius:'5px'
		}"
	>

        <div class="icon">
			<svg id="interface_4_" data-name="interface (4)" xmlns="http://www.w3.org/2000/svg" width="16.41" height="16.093" viewBox="0 0 16.41 16.093">
				<g id="Group_357" data-name="Group 357" transform="translate(0 0)">
					<g id="Group_356" data-name="Group 356">
						<path id="Path_63" data-name="Path 63" d="M15.535,11.177,2.484,4.861a1.73,1.73,0,0,0-2.36,2.2l2.039,5.1H16.41A1.716,1.716,0,0,0,15.535,11.177Z" transform="translate(0 -4.688)" :fill="textColor"/>
					</g>
				</g>
				<g id="Group_359" data-name="Group 359" transform="translate(0.001 8.622)">
					<g id="Group_358" data-name="Group 358">
						<path id="Path_64" data-name="Path 64" d="M2.194,259.9.155,265a1.73,1.73,0,0,0,2.36,2.2l13.051-6.318a1.716,1.716,0,0,0,.875-.98Z" transform="translate(-0.032 -259.904)" :fill="textColor"/>
					</g>
				</g>
			</svg>
        </div>
        <div class="label">
			{{ label || 'Start a Conversation' }}
        </div>
    </button>
</template>

<script>

export default {

	props: {

		label: String,
		buttonType: {
			type: String,
			required: false,
			default: 'outline',
		}

	},

	computed: {

		activeColor() {
			try {
				return this.$root.configuration.style.activeColor;
			}catch(e){
				return '#296df6';
			}
		},
		textColor() {
			if(this.buttonType === 'filled')
				return '#ffffff';
			return this.activeColor;
		},
		backgroundColor() {
			if(this.buttonType === 'filled')
				return this.activeColor
			return '#ffffff';
				
		},
		borderColor() {
			return this.activeColor
		},

		visibility() {
			try{
				return this.$root.configuration.control.canCreateNewConversations;
			}
			catch(e) {
				return true
			}
		},
	}
}

</script>

<style lang="scss">
.btn.rp-start-conversation {
	background: #fff;
	padding: .75rem 1rem;
	// border-radius: 4px;
	color: white;
	font-size: 12px;
	@include for-size(desktop-up){
		font-size: 16px;
	}
	letter-spacing: 1px;
	word-spacing: 1px;
	display: flex;
	align-items: center;
	justify-content: center;

	.label {
		font-weight: 500;
		padding-left: 7px;
		font-size: 14px;
		letter-spacing: 1px;
		@include for-size(desktop-up){
			font-size: 16px;
		}
		font-family: $font;
	}

	.icon {
		width: 15px;
		height: 15px;

		svg {
			display: block;
		}
	}

	&.small {
		padding: .7rem 1.2rem;
		font-size: 12px;

		.icon {
			width: 12px;
			height: 12px;
		}
	}
}
</style>
